import { render, staticRenderFns } from "./InactiveCustomers.vue?vue&type=template&id=0a5c8241&"
import script from "./InactiveCustomers.vue?vue&type=script&lang=js&"
export * from "./InactiveCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports